<template>
  <div>
    <basic-container ref="eltable">
      <div class="page-container activity-manage-page" v-if="!showAdd">
        <div class="tabs">
          <el-tabs :value="activiedTab" type="card" @tab-click="handleTabClick">
            <el-tab-pane name="1" label="线上数据"></el-tab-pane>
            <el-tab-pane name="0" label="本地数据"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="table table-wrap" v-loading="listLoading" element-loading-text="加载中">
          <div class="local-table" v-if="isLocal">
            <avue-crud :option="avueOption" :table-loading="loading" @selection-change="handleSelect" :data="tableData"
              ref="crud" :page.sync="page" @on-load="getList">
              <template slot="menuLeft">
                <div class="query-form-wrap">
                  <el-form :inline="true" :model="form" :size="formSize">
                    <el-form-item>
                      <DynamicOption
                        v-model="form.appId"
                        placeholder="渠道"
                        :singleSelect="true"
                        class="search-item"
                      />
                    </el-form-item>
                    <el-form-item>
                      <el-select clearable v-model="form.status" placeholder="状态">
                        <el-option v-for="item in activityStatus" :key="item.dictKey" :label="item.dictValue"
                          :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select clearable v-model="form.promotionType" placeholder="活动类型">
                        <el-option v-for="item in promotionTypes" :key="item.dictKey" :label="item.dictValue"
                          :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-show="isLocal">
                      <el-select clearable v-model="form.reviewStatus" placeholder="审核状态">
                        <el-option v-for="item in approveStatus" :key="item.dictKey" :label="item.dictValue"
                          :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select clearable v-model="form.giftId" placeholder="赠品类型">
                        <el-option v-for="item in giftTypeOptions" :key="item.id" :label="item.giftName"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select clearable v-model="form.isSms" placeholder="短信提醒">
                        <el-option v-for="item in SMSStatus" :key="item.dictKey" :label="item.dictValue"
                          :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input clearable v-model="form.promotionName" placeholder="活动名称/活动ID"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button v-auth="'ACTIVITY_SEARCH'" :loading="listLoading" icon="el-icon-search" type="primary"
                        @click="handleSearch">搜索</el-button>
                      <el-button v-auth="'ACTIVITY_ADD'" v-show="isLocal" icon="el-icon-plus" plain type="primary"
                        @click="handleOpen">新增</el-button>
                      <el-button v-auth="'ACTIVITY_DELETE'" v-show="isLocal" icon="el-icon-delete" :loading="delLoading"
                        plain type="danger" @click="handleDelete">删除</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </template>
              <template slot-scope="scope" slot="appName">
                <template v-if="scope.row.appName !== ''">
                  <template v-if="scope.row.appNames.length < 5">
                    <el-tag size="mini" v-for="(item, index) in scope.row.appNames" :key="index">{{ item }}</el-tag>
                  </template>
                  <template v-else>
                    <el-tag size="mini" style="margin-right: 10px">{{
                      scope.row.appNames[0]
                    }}</el-tag>
                    <el-popover placement="right" width="400" trigger="click">
                      <div>
                        <el-tag size="mini" v-for="(item, index) in scope.row.appNames" :key="index">{{ item }}</el-tag>
                      </div>
                      <el-tag size="mini" slot="reference">.....</el-tag>
                    </el-popover>
                  </template>
                </template>
                <template v-else>
                  <el-tag size="mini">全部渠道</el-tag>
                </template>
              </template>
              <template slot-scope="scope" slot="productName">
                <template v-if="scope.row.productName">
                  <el-tag size="mini" type="warning" v-for="(item, index) in scope.row.productName" :key="index">{{ item
                    }}</el-tag>
                </template>
                <template v-else>
                  <span>-</span>
                </template>
              </template>
              <template slot-scope="scope" slot="leftAmount">
                <template v-if="scope.row.giftMode == 1">
                  <template v-if="scope.row.leftAmount > 0">
                    <span type="text">{{ scope.row.leftAmount }}</span>
                  </template>
                </template>
                <template v-else> - </template>
              </template>
              <template slot-scope="scope" slot="startDate">
                <span>{{ scope.row.startDate }} 至 {{ scope.row.endDate }}</span>
              </template>
              <template slot-scope="scope" slot="maxAmount">
                <span>{{
                  scope.row.maxAmount > 0 ? scope.row.maxAmount : "无限制"
                }}</span>
              </template>
              <template slot-scope="scope" slot="menu">
                <el-button v-auth="'ACTIVITY_VIEW_LOG'" size="mini" type="text"
                  @click="handleCheckLogs(scope.row)">查看日志</el-button>
                <el-button v-auth="'ACTIVITY_EDIT'" v-show="isLocal && scope.row.reviewStatus != 1" size="mini"
                  type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button v-auth="'ACTIVITY_ADD'" v-show="isLocal && scope.row.reviewStatus != 1" size="mini"
                  type="text" @click="handleCopy(scope.row)">复制</el-button>
                <el-button v-auth="'ACTIVITY_APPROVE'" size="mini" v-show="scope.row.reviewStatus == 1" type="text"
                  :loading="approveLoading" @click="handleApprove(scope.row)">审核</el-button>
                <el-button v-auth="'ACTIVITY_REVOCATION'" size="mini" v-show="scope.row.reviewStatus == 1" type="text"
                  :loading="approveLoading" @click="handleRevocation(scope.row)">撤销审核</el-button>
                <el-button v-auth="'ACTIVITY_APPROVE_SUBMIT'" size="mini" v-show="scope.row.reviewStatus == 0"
                  type="text" :loading="approveLoading" @click="handleApproveRequest(scope.row)">提交审核</el-button>
              </template>
            </avue-crud>
          </div>
          <div class="online-table" v-else>
            <avue-crud :option="onLineOption" :table-loading="loading" :data="tableData" ref="crud2" :page.sync="page"
              @on-load="getList">
              <template slot="menuLeft">
                <div class="query-form-wrap">
                  <el-form :inline="true" :model="form" :size="formSize">
                    <el-form-item>
                      <DynamicOption
                        v-model="form.appId"
                        placeholder="渠道"
                        :singleSelect="true"
                        class="search-item"
                      />
                    </el-form-item>
                    <el-form-item>
                      <el-select clearable v-model="form.status" placeholder="状态">
                        <el-option v-for="item in activityStatus" :key="item.dictKey" :label="item.dictValue"
                          :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select clearable v-model="form.promotionType" placeholder="活动类型">
                        <el-option v-for="item in promotionTypes" :key="item.dictKey" :label="item.dictValue"
                          :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-show="isLocal">
                      <el-select clearable v-model="form.reviewStatus" placeholder="审核状态">
                        <el-option v-for="item in approveStatus" :key="item.dictKey" :label="item.dictValue"
                          :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select clearable v-model="form.giftId" placeholder="赠品类型">
                        <el-option v-for="item in giftTypeOptions" :key="item.id" :label="item.giftName"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select clearable v-model="form.isSms" placeholder="短信提醒">
                        <el-option v-for="item in SMSStatus" :key="item.dictKey" :label="item.dictValue"
                          :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input clearable v-model="form.promotionName" placeholder="活动名称/活动ID"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button v-auth="'ACTIVITY_SEARCH'" :loading="listLoading" icon="el-icon-search" type="primary"
                        @click="handleSearch">搜索</el-button>
                      <el-button v-auth="'ACTIVITY_ADD'" v-show="isLocal" icon="el-icon-plus" plain type="primary"
                        @click="handleOpen">新增</el-button>
                      <el-button v-auth="'ACTIVITY_DELETE'" v-show="isLocal" icon="el-icon-delete" :loading="delLoading"
                        plain type="danger" @click="handleDelete">删除</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </template>
              <template slot-scope="scope" slot="appName">
                <template v-if="scope.row.appName !== ''">
                  <template v-if="scope.row.appNames.length < 5">
                    <el-tag size="mini" v-for="(item, index) in scope.row.appNames" :key="index">{{ item }}</el-tag>
                  </template>
                  <template v-else>
                    <el-tag size="mini" style="margin-right: 10px">{{
                      scope.row.appNames[0]
                    }}</el-tag>
                    <el-popover placement="right" width="400" trigger="click">
                      <div>
                        <el-tag size="mini" v-for="(item, index) in scope.row.appNames" :key="index">{{ item }}</el-tag>
                      </div>
                      <el-tag size="mini" slot="reference">.....</el-tag>
                    </el-popover>
                  </template>
                </template>
                <template v-else>
                  <el-tag size="mini">全部渠道</el-tag>
                </template>
              </template>
              <template slot-scope="scope" slot="productName">
                <template v-if="scope.row.productName">
                  <el-tag size="mini" type="warning" v-for="(item, index) in scope.row.productName" :key="index">{{ item
                    }}</el-tag>
                </template>
                <template v-else>
                  <span>-</span>
                </template>
              </template>
              <template slot-scope="scope" slot="leftAmount">
                <template v-if="scope.row.giftMode == 1">
                  <template v-if="scope.row.leftAmount > 0">
                    <router-link :to="{
                      path: '/runActivityManage/giftManage',
                      query: { id: scope.row.giftId, status: '1' }
                    }">
                      <el-button style="text-decoration: underline" type="text">{{ scope.row.leftAmount }}</el-button>
                    </router-link>
                  </template>
                </template>
                <template v-else> - </template>
              </template>
              <template slot-scope="scope" slot="startDate">
                <span>{{ scope.row.startDate }} 至 {{ scope.row.endDate }}</span>
              </template>
              <template slot-scope="scope" slot="maxAmount">
                <span>{{
                  scope.row.maxAmount > 0 ? scope.row.maxAmount : "无限制"
                }}</span>
              </template>
              <template slot-scope="scope" slot="menu">
                <el-button size="mini" type="text"
                           @click="handleCheckSendInfo(scope.row)">查看发放信息</el-button>
              </template>
            </avue-crud>
            <!-- <a-table :options="onlineOptions" :data="activityList" :height="localTableHeight">
            <template slot-scope="scope" slot="date">
              <span>{{scope.row.startDate}} 至 {{scope.row.endDate}}</span>
            </template>
            <template slot-scope="scope" slot="maxAmount">
              <span>{{scope.row.maxAmount > 0 ? scope.row.maxAmount : '无限制' }}</span>
            </template>
          </a-table> -->
          </div>
        </div>
        <!-- <div class="table-pagination">
        <TablePagination
          :page-size.sync="pageConfig.size"
          :total="total"
          :current-page.sync="pageConfig.current"
          @change="handlePageChange"
        />
      </div> -->
      </div>
      <add-activity-form v-else :is-edit="isEdit" :is-copy="isCopy" @reload="handleSearch" :row="currentRow"
        @cancel="handleCancel"></add-activity-form>
      <el-dialog width="600px" title="审核" custom-class="approve-dialog__wrap" :visible.sync="showApprove"
        @close="handleClose" append-to-body>
        <div class="approve-popups-inner__body">
          <div class="approve-popups-from__wrap">
            <el-form :size="formSize" :model="approveForm" ref="approve" :rules="formRules" label-width="120px">
              <el-form-item label="配置渠道">
                <p class="activity-content channel">
                  {{
                    currentRow.appName === "" ? "全渠道" : currentRow.appName
                  }}
                </p>
              </el-form-item>
              <el-form-item label="活动名称">
                <p class="activity-content">{{ currentRow.name }}</p>
              </el-form-item>
              <!--    <el-form-item label="赠送条件">
                <p class="activity-content">
                  {{
                    currentRow.productName
                      ? currentRow.productName.join(",")
                      : "-"
                  }}
                </p>
              </el-form-item> -->
              <!-- <el-form-item label="赠品类型">
                <p class="activity-content">{{ currentRow.giftName }}</p>
              </el-form-item> -->
              <!-- <el-form-item label="可赠送最大数量">
                <p class="activity-content">{{ currentRow.maxAmount }}</p>
              </el-form-item> -->
              <el-form-item label="有效期">
                <p class="activity-content">
                  {{ currentRow.startDate }} 至 {{ currentRow.endDate }}
                </p>
              </el-form-item>
              <el-form-item label="状态">
                <p class="activity-content">{{ formatStatus(currentRow) }}</p>
              </el-form-item>
              <!-- <el-form-item label="短信提醒">
                <p class="activity-content">{{ formatSms(currentRow) }}</p>
              </el-form-item> -->
              <!-- <el-form-item
                label="短信模板ID"
                v-if="currentRow.isSmsNotice == 1"
              >
                <p class="activity-content">
                  {{ currentRow.smsNoticeTemplate }}
                </p>
              </el-form-item> -->
              <el-form-item label="备注">
                <p class="activity-content">{{ currentRow.remark }}</p>
              </el-form-item>

              <div style="position: relative" v-for="(item, index) in currentRow.ruleList" :key="index">
                <div v-if="currentRow.promotionType == 4" style="width: 80%; padding-bottom: 30px;">
                  <el-form-item label="会员商品：">
                    <el-cascader disabled placeholder="会员商品" :props="{ multiple: true }" :options="memberGoods"
                      size="small" separator="-" v-model="item.productId" @change="val => {
                        $set(item, 'productId', val);
                      }
                        ">
                    </el-cascader>
                  </el-form-item>

                  <el-form-item label="商品图片：">
                    <el-image class="avatar" :src="item.goodsPic" fit="scale-down"></el-image>
                  </el-form-item>
                  <el-form-item label="权益图片：">
                    <el-image class="avatar" :src="item.rightsPic" fit="scale-down"></el-image>
                  </el-form-item>
                  <el-form-item label="乐播图片：">
                    <el-image class="avatar" :src="item.leboPic" fit="scale-down"></el-image>
                  </el-form-item>
                  <el-form-item label="按钮图片：">
                    <el-image class="avatar" :src="item.buttonImageUrl" fit="scale-down"></el-image>
                  </el-form-item>

                  <el-form-item label="活动说明：">
                    <div v-html="item.promotionDescribe"></div>
                  </el-form-item>
                </div>
                <!-- 优惠券活动的审核 -->
                <div v-if="currentRow.promotionType == 5" style="width: 80%;padding-bottom: 30px">
                  <el-form-item :label="'活动规则' + (index + 1)">{{ item.ruleTypeLabel }}
                  </el-form-item>
                  <div style="margin-left: 50px">
                    <!-- 用户类型 -->
                    <el-form-item label="用户类型">
                      <p class="activity-content">{{ item.userTypeLabel }}</p>
                    </el-form-item>
                    <!-- 用户标签 -->
                    <el-form-item v-if="item.userType === '1'" label="用户标签">
                      <p class="activity-content">
                        {{ item.userTagsLabel ? item.userTagsLabel : "-" }}
                      </p>
                    </el-form-item>
                    <!-- 用户数量 -->
                    <el-form-item v-if="item.userType === '1'" label="用户数量">
                      <p class="activity-content">
                        {{ item.userAmountLabel ? item.userAmountLabel : "-" }}
                      </p>
                    </el-form-item>
                    <!-- 客户端类型 -->
                    <el-form-item v-if="item.isAllPlatform == '1'" label="客户端类型">
                      <p class="activity-content">
                        {{ item.isAllPlatform == 1 ? '全部端' : "指定端" }}
                      </p>
                    </el-form-item>
                    <!-- 指定端 -->
                    <el-form-item v-if="item.isAllPlatform == '0'" label="指定端">
                      <p class="activity-content">
                        {{ item.platformLabel ? item.platformLabel : "-" }}
                      </p>
                    </el-form-item>
                    <!-- 赠品类型 -->
                    <el-form-item label="赠品类型">
                      <p class="activity-content">
                        {{ item.couponLabel ? item.couponLabel : '-' }}
                      </p>
                    </el-form-item>

                    <!-- 触发资源位 -->
                    <el-form-item label="触发资源位">
                      <p class="activity-content">
                        {{ item.resourceLabel ? item.resourceLabel : "-" }}
                      </p>
                    </el-form-item>

                    <!-- 触发场景 -->
                    <el-form-item label="触发场景">
                      <p class="activity-content">
                        {{ item.triggerSceneLabel ? item.triggerSceneLabel : "-" }}
                      </p>
                    </el-form-item>

                    <!-- 发放次数 -->
                    <el-form-item label="发放次数">
                      <p class="activity-content">
                        {{ item.provideAmountLabel ? item.provideAmountLabel : "-" }}
                      </p>
                    </el-form-item>

                    <!-- 过期是否重复发放 -->
                    <el-form-item label="过期重复发放">
                      <p class="activity-content">
                        {{ item.duplicateProvideLabel }}
                      </p>
                    </el-form-item>

                    <!-- 短信提醒 -->
                    <el-form-item label="短信提醒">
                      <p class="activity-content">
                        {{ item.isSmsNoticeLabel }}
                      </p>
                    </el-form-item>
                    <!-- 短信模板ID -->
                    <el-form-item v-if="item.isSmsNotice == '1'" label="短信模板ID">
                      <p class="activity-content">
                        {{ item.smsNoticeTemplateLabel }}
                      </p>
                    </el-form-item>
                    <!-- push提醒 -->
                    <el-form-item label="push提醒">
                      <p class="activity-content">
                        {{ item.isPushNoticeLabel }}
                      </p>
                    </el-form-item>
                    <!-- push模板ID -->
                    <el-form-item v-if="item.isPushNotice == '1'" label="push模板ID">
                      <p class="activity-content">
                        {{ item.pushNoticeTemplateLabel }}
                      </p>
                    </el-form-item>
                  </div>

                </div>
                <div v-else>
                  <el-form-item :label="'活动规则' + (index + 1)">{{ item.ruleTypeLabel }}
                  </el-form-item>
                  <div style="margin-left: 50px">
                    <!-- 用户类型 -->
                    <el-form-item label="用户类型">
                      <p class="activity-content">{{ item.userTypeLabel }}</p>
                    </el-form-item>
                    <!-- 用户标签 -->
                    <el-form-item v-if="item.userType === '1'" label="用户标签">
                      <p class="activity-content">
                        {{ item.userTagsLabel ? item.userTagsLabel : "-" }}
                      </p>
                    </el-form-item>
                    <!-- 用户数量 -->
                    <el-form-item v-if="item.userType === '1'" label="用户数量">
                      <p class="activity-content">
                        {{ item.userAmountLabel ? item.userAmountLabel : "-" }}
                      </p>
                    </el-form-item>
                    <!-- 触发条件 -->
                    <el-form-item label="触发条件">
                      <p class="activity-content">{{ item.activeModeLabel }}</p>
                    </el-form-item>
                    <!-- 会员类别 -->
                    <el-form-item v-if="[1, 2].includes(+item.activeMode)" label="会员类别">
                      <p class="activity-content">{{ item.vipTypeLabel }}</p>
                    </el-form-item>
                    <!-- 会员商品 -->
                    <el-form-item v-if="[1, 2].includes(+item.activeMode)" label="会员商品">
                      <p class="activity-content">{{ item.productIdLabel }}</p>
                    </el-form-item>
                    <!-- 邀请人数 -->
                    <el-form-item v-if="item.activeMode === '4'" label="邀请人数">
                      <p class="activity-content">
                        {{ item.provideThresholdLabel }}
                      </p>
                    </el-form-item>
                    <!-- 赠品类型 -->
                    <el-form-item label="赠品类型">
                      <p class="activity-content">{{ item.giftIdLabel }}</p>
                    </el-form-item>
                    <!-- 可赠送最大数量 -->
                    <el-form-item label="可赠送最大数量">
                      <p class="activity-content">{{ item.maxAmountLabel }}</p>
                    </el-form-item>
                    <!-- 单账号发放数量 -->
                    <el-form-item label="单账号发放数量">
                      <p class="activity-content">
                        {{ item.userAmountLabel }}
                      </p>
                    </el-form-item>
                    <!-- 短信提醒 -->
                    <el-form-item label="短信提醒">
                      <p class="activity-content">
                        {{ item.isSmsNoticeLabel }}
                      </p>
                    </el-form-item>
                    <!-- 短信模板ID -->
                    <el-form-item v-if="item.isSmsNotice == '1'" label="短信模板ID">
                      <p class="activity-content">
                        {{ item.smsNoticeTemplateLabel }}
                      </p>
                    </el-form-item>
                    <!-- push提醒 -->
                    <el-form-item label="push提醒">
                      <p class="activity-content">
                        {{ item.isPushNoticeLabel }}
                      </p>
                    </el-form-item>
                    <!-- push模板ID -->
                    <el-form-item v-if="item.isPushNotice == '1'" label="push模板ID">
                      <p class="activity-content">
                        {{ item.pushNoticeTemplateLabel }}
                      </p>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <el-form-item label="审核意见" prop="content">
                <el-input clearable type="textarea" :rows="2" v-model="approveForm.content"
                  placeholder="审核意见"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button :size="formSize" type="success" :loading="approveLoading" @click="handleApproved">审核通过</el-button>
          <el-button :size="formSize" type="warning" :loading="approveLoading"
            @click="handleRejectApprove">审核不通过</el-button>
          <el-button :size="formSize" @click="handleCancelApprove">取消</el-button>
        </span>
      </el-dialog>
      <approve-log-popups :logs="logs" :visible.sync="showLog"></approve-log-popups>
    </basic-container>
  </div>
</template>
<script>
import { getMemberGoods } from "@/api/memberNew/memberUnite";
import {
getActivityList,
getBigDataTags,
getCouponList,
getProtocolReceiveType,
getProtocolSendType,
getResourceGroup,
getPromotinSendInfo
} from "@/api/runActivityManage/activity";
import { getPushList } from "@/api/runActivityManage/pushManage";
import ApproveLogPopups from "@/components/ApproveLogPopups";
import DynamicOption from "@/components/DynamicOption/index.vue";
import { merge } from "@/util/common";
import ListMixins from "@/util/mixins/listPage";
import { uniteMemberGoodsFormat } from "@/views/memberNew/memberUnite/helper/index";
import { mapActions, mapGetters, mapState } from "vuex";
import AddActivityForm from "./addActivity";
export default {
  name: "ActivityManagePage",
  mixins: [ListMixins],
  data() {
    const checkContent = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入审核意见"));
      } else {
        callback();
      }
    };
    return {
      /** tag为优惠券的资源位 */
      appResourceGroupCodeOptions: [],
      /** 优惠券列表 */
      couponList: [],
      /** 收发端list */
      clientTypeList: [],
      memberGoods: [],
      userTagOptions: [],
      pushTemplateList: [],
      tableData: [],
      loading: false,
      showLog: false,
      showAdd: false,
      isEdit: false,
      isCopy: false,
      currentRow: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      avueOption: {
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        height: "auto",
        calcHeight: 200,
        tip: false,
        searchShow: true,
        searchMenuSpan: 2,
        border: true,
        index: false,
        selection: true,
        column: [
          {
            label: "活动ID",
            prop: "originalId",
            width: 200,
            align: "left"
          },
          {
            label: "渠道命中类型",
            prop: "channelType",
            width: 120,
            align: "left",
            formatter: this.formatChannelType
          },
          {
            label: "渠道",
            prop: "appName",
            slot: true,
            width: 200,
            align: "left"
          },
          {
            label: "活动类型",
            prop: "promotionType",
            formatter: this.formatPromotionType,
            with: 200,
            align: "center"
          },
          {
            label: "活动名称",
            prop: "name",
            width: 180,
            align: "left"
          },
          {
            label: "状态",
            prop: "status",
            formatter: this.formatStatus,
            width: 80,
            align: "center"
          },
          {
            label: "审核状态",
            formatter: this.formatApproveStatus,
            prop: "reviewStatus",
            width: 80,
            align: "center"
          },
          {
            label: "有效期",
            prop: "startDate",
            slot: true,
            width: 310,
            align: "center"
          },
          {
            label: "备注",
            prop: "remark",
            width: 200,
            align: "left"
          }
        ]
      },
      onLineOption: {
        menu: true,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        height: "auto",
        calcHeight: 200,
        tip: false,
        searchShow: true,
        searchMenuSpan: 2,
        border: true,
        index: false,
        selection: false,
        column: [
          {
            label: "活动ID",
            prop: "id",
            width: 200,
            align: "left"
          },
          {
            label: "渠道命中类型",
            prop: "appType",
            formatter: this.formatChannelType,
            width: 120,
            align: "left"
          },
          {
            label: "渠道",
            prop: "appName",
            slot: true,
            width: 200,
            align: "left"
          },
          {
            label: "活动类型",
            prop: "promotionType",
            formatter: this.formatPromotionType,
            with: 200,
            align: "center"
          },
          {
            label: "活动名称",
            prop: "name",
            width: 180,
            align: "left"
          },
          {
            label: "状态",
            formatter: this.formatStatus,
            prop: "status",
            width: 80,
            align: "center"
          },
          {
            label: "有效期",
            slot: true,
            prop: "startDate",
            width: 310,
            align: "center"
          },
          {
            label: "备注",
            prop: "remark",
            width: 200,
            align: "left"
          }
        ]
      },
      form: {
        reviewStatus: "",
        isUsed: "1", // 1: 线上， 2： 线下
        giftId: "", // 赠品类型
        promotionType: "", // 活动类型
        appId: "", // 渠道
        isSms: "", // 短信提醒,0：不提醒，1：提醒
        promotionName: "", // 活动名称
        status: ""
      },
      showApprove: false,
      approveLoading: false,
      listLoading: false,
      submitLoading: false,
      delLoading: false,
      selectedAll: false,
      channel: 1,
      formRules: {
        content: [
          {
            validator: checkContent,
            message: "请输入审核意见",
            trigger: "blur"
          }
        ]
      },
      approveForm: {
        content: "",
        bizRefrenceId: "",
        status: "" // 0草稿 1提交审核 2审核通过 3审核拒绝 4撤销审核
      }
    };
  },
  components: {
    ApproveLogPopups,
    AddActivityForm,
    DynamicOption
  },
  watch: {
    total(val) {
      this.page.total = val;
    }
  },
  computed: {
    ...mapState("runActivityManage", [
      "total",
      "activityList",
      "channelList",
      "activiedTab",
      "productList",
      "smsTemplateList"
    ]),
    ...mapGetters("app", ["viewportSize", "logs"]),
    ...mapGetters("runActivityManage", [
      "giftTypeOptions",
      "SMSStatus",
      "activityStatus",
      "giveConditions",
      "promotionTypes",
      "approveStatus"
    ]),
    isLocal() {
      return this.activiedTab === "0";
    },
    onlineRows() {
      return this.activiedTab === "1" ? [1] : [];
    },
    localRow() {
      return this.activiedTab === "0" ? [1] : [];
    }
  },
  methods: {
    formatChannelType(row) {
      switch (row.appType) {
        case 1:
          return "全部渠道";
        case 2:
          return "渠道白名单";
        case 3:
          return "渠道黑名单";
      }
      return "";
    },
    handleTabClick({ name }) {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.form.isUsed = name;
      this.changeTab(name);
      this.getList();
    },
    ...mapActions("app", ["getLogs"]),
    ...mapActions("runActivityManage", [
      "changeTab",
      "getActivities",
      "getDicts",
      "getGiftTypeOptions",
      "getChannelList",
      "handupApprove",
      "handleApporveFlow",
      "removeActivitys"
    ]),
    /** 获取大数据用户标签 */
    async getUserTagOptions() {
      const { data } = await getBigDataTags();
      console.log("获取大数据用户标签的响应", data);
      this.userTagOptions = data.data;
    },
    /** 获取以会员类型分组所有的会员商品 */
    async getMemberGoods() {
      const { data } = await getMemberGoods();
      console.log("获取以会员类型分组所有的会员商品接口的响应", data);
      this.memberGoods = uniteMemberGoodsFormat(data.data);
      /** 会员商品map */

      // 回显示数据
      this.currentRow.ruleList.forEach(item => {
        if (this.currentRow.promotionType === "4" && item.productId) {
          /** 修改memberGoodsMap里面的label */
          const ids = Array.isArray(item.productId)
            ? item.productId
            : item.productId.split(",");
          const GoodsIds = this.findMatchingData(ids, this.memberGoods);
          this.$set(item, "productId", GoodsIds);
        }
      });
    },
    // 回显示商品cascader
    findMatchingData(values, data) {
      const result = [];
      data.forEach(item => {
        item.children.forEach(child => {
          if (values.includes(String(child.value))) {
            // 判断值是否在values中
            result.push([item.value, child.value]); // 将父级value和子级value组合
          }
        });
      });
      return result;
    },
    /** 获取push列表 */
    async getPushList() {
      const params = {
        current: 1,
        size: 9999,
        name: ""
      };
      const { data } = await getPushList(params);
      console.log("获取push列表的响应", data);
      this.pushTemplateList = data.data.records;
    },
    // 获取日志
    handleCheckLogs(row) {
      this.showLog = true;
      this.getLogs({
        bizCode: 30,
        bizRefrenceId: row.id
      });
    },
    async handleCheckSendInfo(row) {
      console.log("查看发放信息", row);
      const { data } = await getPromotinSendInfo({"promotionId": row.id});
      if (data && data.code === 200) {
        this.$message.success(`${data.data}`);
      } else {
        this.$message.error(`发放信息获取失败: ${data.message || "未知错误"}`);
      }

    },
    // 审核内容
    handleApprove(row) {
      console.log("审核内容", row);
      const params = { ...row };
      /** 处理数据 */
      params.ruleList.forEach(item => {
        if (!Array.isArray(item.giftId)) {
          item.giftId = item.giftId.split(",");
        }
        if (!Array.isArray(item.userTags)) {
          item.userTags = item.userTags.split(",");
        }
        if (!Array.isArray(item.productId)) {
          item.productId = item.productId.split(",");
        }

        /** 活动规则的用户类型 */
        for (let key of Object.keys(item)) {
          if (item[key] !== "" && !Array.isArray(item[key])) {
            item[key] = item[key] + "";
          }
        }

        /** 邀请用户/被邀请用户 */
        if (item.ruleType === "") {
          item.ruleTypeLabel = "";
        } else {
          if (item.ruleType == 0) {
            item.ruleTypeLabel = "邀请用户";
          } else if (item.ruleType == 1) {
            item.ruleTypeLabel = "被邀请用户";
          } else {
            item.ruleTypeLabel = "";
          }
        }
        item.userTypeOptions = [
          {
            label: "全部用户",
            value: "0"
          },
          {
            label: "指定标签",
            value: "1"
          },
          {
            label: "指定用户",
            value: "2"
          },
          {
            label: "前端指定用户",
            value: "3"
          }
        ];
        item.userTypeLabel = item.userTypeOptions.find(
          i => i.value == item.userType
        ).label;
        /** 用户标签 */
        item.userTagsLabel = this.userTagOptions
          .filter(i => item.userTags.includes(i.tag))
          .map(i => i.tag)
          .join(",");
        /** 用户数量 */
        item.userAmountLabel = this.userTagOptions
          .filter(i => item.userTags.includes(i.tag))
          .reduce((total, item) => total + item.qty, 0);
        /** 触发条件 */
        const res4 = this.giveConditions.find(
          i => i.dictKey == item.activeMode
        );
        item.activeModeLabel = res4 ? res4.dictValue : "";
        /** 会员类别 + 会员商品 + 邀请人数*/
        console.log("会员商品", this.productList);

        if ([1, 2].includes(+item.activeMode)) {
          item.vipTypeLabel = "会员类别:乐播云个人会员";
          const res = this.productList.filter(i =>
            item.productId.includes(i.id)
          );
          if (res.length > 0) {
            console.log("res", res);
            item.productIdLabel = res
              .map(ele => ele.productCode + ele.name)
              .join(",");
          } else {
            item.productIdLabel = "";
          }
        } else if (item.activeMode == 4) {
          item.provideThresholdLabel =
            "邀请人数: " +
            item.provideThreshold +
            "最多邀请" +
            item.maxInvitation +
            "人";
        }
        /** 赠品类型 */
        const res = this.giftTypeOptions.find(i => i.id == item.giftId);
        item.giftIdLabel = res ? res.giftName : "-";

        /** 可赠送最大数量 */
        item.maxAmountLabel = item.maxAmount;
        /** 单账号发放数量 */
        item.userAmountLabel = item.userAmount;
        /** 短信提醒 */
        item.isSmsNoticeLabel = item.isSmsNotice == 1 ? "是" : "否";
        /** 短信模板ID */
        const res2 = this.smsTemplateList.find(
          i => i.smsCode == item.smsNoticeTemplate
        );
        item.smsNoticeTemplateLabel = res2 ? res2.remark : "";
        /** push提醒 */
        item.isPushNoticeLabel = item.isPushNotice == 1 ? "是" : "否";
        /** push模板ID */
        const res3 = this.pushTemplateList.find(
          i => i.id == item.pushNoticeTemplate
        );
        item.pushNoticeTemplateLabel = res3 ? res3.name : "";

        /** 处理优惠券活动 */
        if (row.promotionType == 5) {
          console.log("🚀 ~ handleApprove ~ promotionType:", !item.isAllPlatform)

          /** 处理指定端 */
          if (item.isAllPlatform != 1) {
            const sendList = item.senderPlatforms.map((sendItem) => {
              return `${sendItem.terminalType}-${sendItem.platformType}`
            })
            const receiveList = item.receiverPlatforms.map((receiveItem) => {
              return `${receiveItem.terminalType}-${receiveItem.platformType}`
            })
            const list = [...sendList, ...receiveList]
            console.log("🚀 ~ handleApprove ~ list:", list)
            // 匹配并生成 platformLabel
            item.platformLabel = this.clientTypeList
              .filter(clientItem => list.includes(clientItem.value))
              .map(clientItem => clientItem.label).join(',')
          }

          /** 处理赠品类型 */
          let couponId = null
          if (!Array.isArray(item.giftId)) {
            item.giftId = item.giftId.split(",");
            couponId = String(item.giftId)
          } else {
            couponId = item.giftId[0]
          }
          const coupon = this.couponList.find(couponItem => couponItem.id == couponId)
          if (coupon) {
            item.couponLabel = coupon.giftName
          }

          /** 处理资源位 */
          item.resourceLabel = this.generateDisplayLabels(item.recourseDTO, this.appResourceGroupCodeOptions)

          /** 处理触发场景 */
          item.triggerSceneLabel = (() => {
            switch (item.triggerScene) {
              case '1':
                return "页面加载时";

              case '2':
                return `在页面停留超过${item.triggerWaitSeconds}秒时`;

              case '3':
                return "主动退出页面时";

              case '4': {
                // 使用大括号包裹 case 块，避免作用域冲突
                const businessMap = {
                  "1": "镜像",
                  "2": "会议",
                  "3": "推送 (含相册、网盘、桥接)",
                };

                const sourceLabels = (item.sourceBusiness.split(',') || []).filter(business => businessMap[business]).map(business => businessMap[business]);
                console.log("🚀 ~ handleApprove ~ sourceLabels:", sourceLabels)
                return sourceLabels.length
                  ? `从${sourceLabels.join(',')}进入触发页面`
                  : "-";
              }

              default:
                return "-";
            }
          })();

          /** 处理发放次数 */
          const provideAmountTypeOptions = [
            { label: "仅发放一次", value: 1 },
            { label: "每端发放一次", value: 2 },
            { label: "每次都发放", value: 3 },
            { label: "按用户限制每日发放次数", value: 4 },
            { label: "按端限制每日发放次数", value: 5 }
          ];

          const matchedOption = provideAmountTypeOptions.find(option => option.value == item.provideAmountType);

          if (matchedOption) {
            if (matchedOption.value == 4 || matchedOption.value == 5) {
              item.provideAmountLabel = `${matchedOption.label}，发放${item.provideAmount}次`;
            } else {
              item.provideAmountLabel = `${matchedOption.label}`;
            }
          }

          console.log("🚀 ~ item.provideAmountLabel=provideAmountTypeOptions.map ~ provideAmountLabel:", item.provideAmountLabel)

          /** 处理过期是否重复发放 */
          item.duplicateProvideLabel = item.duplicateProvide == 1 ? '是' : '否'

        }
      });
      console.log("params", params);
      this.currentRow = params;
      this.getMemberGoods();
      this.showApprove = true;
    },
    /** 处理资源位数据 */
    generateDisplayLabels(recourseDTO, appResourceGroupCodeOptions) {
      const displayLabels = [];

      recourseDTO.forEach(({ appResourceGroupId, appResourceItemId }) => {
        // 找到对应的资源组
        const group = appResourceGroupCodeOptions.find(item => item.value == appResourceGroupId);

        if (group) {
          const groupLabel = group.label;

          // 如果资源位数组为空，只显示资源组的 label
          if (!appResourceItemId || appResourceItemId.length == 0) {
            displayLabels.push(groupLabel);
          } else {
            // 遍历资源位，找到对应的 label
            appResourceItemId.forEach(itemId => {
              const resource = group.children.find(child => child.value == itemId);
              if (resource) {
                displayLabels.push(`${groupLabel} - ${resource.label}`);
              }
            });
          }
        }
      });

      return displayLabels.join(',');
    },

    // 审核 通过
    handleApproved() {
      const query = merge({}, this.approveForm, {
        bizRefrenceId: this.currentRow.id,
        status: 2
      });
      this.submitApprove(query);
    },
    // 撤销审核
    handleRevocation(row) {
      const query = merge(
        {},
        {
          bizRefrenceId: row.id,
          status: 4
        }
      );
      this.submitApprove(query);
    },
    // 审核不通过
    handleRejectApprove() {
      this.$refs.approve.validate(valid => {
        if (valid) {
          const query = merge({}, this.approveForm, {
            bizRefrenceId: this.currentRow.id,
            status: 3
          });
          this.submitApprove(query);
        }
      });
    },
    submitApprove(data) {
      this.approveLoading = true;
      this.handleApporveFlow(data)
        .then(success => {
          if (success) {
            this.handleCancelApprove();
            this.getList();
          }
        })
        .finally(() => {
          this.approveLoading = false;
        });
    },
    handleClose() {
      this.$refs.approve.clearValidate();
      this.approveForm.content = "";
    },
    handleCancelApprove() {
      this.currentRow = {};
      this.showApprove = false;
    },
    // 审核申请
    handleApproveRequest(row) {
      this.approveLoading = true;
      this.handupApprove({
        bizRefrenceId: row.id,
        status: 1 // 提交审核
      })
        .then(isSuccess => {
          if (isSuccess) {
            this.getList();
          }
        })
        .finally(() => {
          this.approveLoading = false;
        });
    },
    getList() {
      const query = merge(
        {},
        this.form,
        { current: this.page.currentPage, size: this.page.pageSize },
        {
          isUsed: this.activiedTab
        }
      );
      this.listLoading = true;
      // 获取赠品活动分页数据
      getActivityList(query)
        .then(response => {
          const res = response.data;
          if (res.code === 200) {
            const data = res.data || {};
            data.records.forEach(element => {
              element.appNames = element.appName.split(",");
              // element.productName = element.productName
              //   .split(",")
              //   .filter((i) => i);
            });
            this.tableData = data.records;
            this.page.total = data.total;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
      // this.getActivities(query).finally(() => {
      //   this.listLoading = false;
      // });
    },
    // 选择数据
    handleSelect(selection) {
      this.selectedRows = selection;
    },
    // 编辑数据
    handleEdit(row) {
      // 待审核 数据不给修改
      if (row.reviewStatus == 1) {
        this.$alert("待审核状态不可修改，请撤销审核后再修改", "提示", {
          confirmButtonText: "知道了"
        });
        return false;
      }
      this.currentRow = { ...row };
      this.isEdit = true;
      this.handleOpen();
    },
    // 复制
    handleCopy(row) {
      // // 待审核 数据不给复制
      // if (row.reviewStatus == 1) {
      //   this.$alert("待审核状态不可修改，请撤销审核后再修改", "提示", {
      //     confirmButtonText: "知道了"
      //   });
      //   return false;
      // }
      this.currentRow = { ...row };
      this.isCopy = true;
      this.handleOpen();

    },
    // 删除数据
    handleDelete() {
      // 如果选中的记录已经审核通过，则提示“该记录已审核通过，不能删除！”
      if (this.selectedRows.length > 0) {
        const hasApproved = this.selectedRows.some(
          item => item.reviewStatus == 2
        );
        if (hasApproved) {
          this.$alert("记录中包含已审核通过的数据，不能删除！", "提示", {
            confirmButtonText: "知道了"
          });
          return false;
        }
        this.$confirm("确定要删除选择的记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const ids = this.selectedRows.map(item => item.id).join(",");
          this.delLoading = true;
          this.removeActivitys({ ids })
            .then(isSuccess => {
              if (isSuccess) {
                this.selectedRows = [];
                this.getList();
              }
            })
            .finally(() => {
              this.delLoading = false;
            });
        });
      } else {
        this.$alert("请选择要删除的记录", "提示", {
          confirmButtonText: "知道了"
        });
      }
    },
    // 打开编辑窗口
    handleOpen() {
      this.showAdd = true;
    },
    // 取消编辑数据
    handleCancel() {
      this.isCopy = false
      this.isEdit = false;
      this.currentRow = {};
      this.selectedRows = [];
      this.showAdd = false;
    },
    // 格式状态
    formatStatus({ status }) {
      for (let item of this.activityStatus) {
        if (item.dictKey == status) {
          return item.dictValue;
        }
      }
    },
    formatPromotionType({ promotionType }) {
      for (let item of this.promotionTypes) {
        if (item.dictKey === promotionType) {
          return item.dictValue;
        }
      }
    },
    formatApproveStatus({ reviewStatus }) {
      for (let item of this.approveStatus) {
        if (item.dictKey == reviewStatus) {
          return item.dictValue;
        }
      }
    },
    formatSms({ isSmsNotice }) {
      for (let item of this.SMSStatus) {
        if (item.dictKey == isSmsNotice) {
          return item.dictValue;
        }
      }
    },
    handleSearchChannel() {
      if (this.channelList.length < 1) {
        this.getChannelList();
      }
    },
    //^ ^--------------数据初始化-------------^ ^
    /** 获取收发端类型 */
    async getClientType() {
      /** 1发端 2收端 */
      const { data: sendData } = await getProtocolSendType();
      console.log("🚀 ~ getClientType ~ sendData:", sendData)
      const sendList = sendData.data.map((item) => {
        return {
          label: item.dictValue,
          value: '1-' + item.dictKey
        }
      })

      const { data: receiveData } = await getProtocolReceiveType();
      const receiveList = receiveData.data.map((item) => {
        return {
          label: item.dictValue,
          value: '2-' + item.dictKey
        }
      })
      console.log("🚀 ~ getClientType ~ receiveData:", receiveData)
      this.clientTypeList = [...sendList, ...receiveList]
    },
    /** 获取优惠券 */
    async getCouponList() {
      const { data } = await getCouponList();
      console.log("🚀 ~ getProtocolList ~ data:", data)
      this.couponList = data.data.records
    },
    /** 获取tag为优惠券的所有资源组及资源位 */
    async getResourceGroupAndResource() {
      const { data } = await getResourceGroup();
      console.log("🚀 ~ getResourceGroupAndResource ~ data:", data);

      this.appResourceGroupCodeOptions = data.data.map((item) => {
        if (item.items && item.items.length) {
          // 如果 item.item 存在，处理为具有子项的格式
          return {
            label: item.name,
            value: item.id,
            children: item.items.map((item2) => {
              return {
                label: item2.title,
                value: item2.id
              };
            })
          };
        } else {
          // 如果 item.item 不存在，返回一个简单的格式
          return {
            label: item.name,
            value: item.id,
          };
        }
      });
    }
  },
  created() {
    this.getResourceGroupAndResource()
    this.getCouponList()
    this.getClientType()
    this.getDicts("PROMOTION_TYPES");
    this.getDicts("GIFT_CATEGORY");
    this.getDicts("YES_NOT");
    this.getDicts("APPROVE_STATUS");
    this.getDicts("ACTIVITY_STATUS");
    this.getGiftTypeOptions();
    this.getPushList();
    this.getUserTagOptions();
  }
};
</script>
<style lang="scss">
.approve-popups-from__wrap {
  max-height: 500px;
  overflow-y: auto;
}

.el-tag+.el-tag {
  margin: 3px;
}

.activity-manage-page .query-form-wrap {
  .el-form-item {
    margin-bottom: 10px;
  }
}

.page-container {
  .tabs {
    margin-bottom: 10px;
  }

  .el-tabs--border-card {
    border-bottom: transparent;
    box-shadow: none;
  }

  .el-tabs--border-card>.el-tabs__content {
    padding: 0;
  }
}

.table-pagination {
  margin-top: 20px;
  text-align: right;
}

.approve-dialog__wrap {
  .activity-content {
    margin: 0;

    &.channel {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .el-form-item__label {
    font-weight: 900;
    color: #000000;
  }

  .el-form-item {
    margin-bottom: 5px;
  }
}
</style>
